export const WEB_INTERACTIVES_URL = '/web-interactives/v1/cos-interactives';
export const LANDING_PAGES_URL = '/cospages/v2/landing-pages';
export const TARGETED_CONTENT_URL = '/targeted/v1/definitions/by-content';